import "./MobileNavbar.css";

import CustomAnchor from "../../Anchor/CustomAnchor";
import Navtabs from "../../../components/navtabs/Navtabs";
import logo from "../../../assets/images/logo/Standout-Black.png";
import { useEffect, useRef } from "react";
import { useAppContext } from "../../../App";

function MobileNavbar() {
  const mobileMenuBtn = useRef<HTMLButtonElement>(null);
  const context = useAppContext();

  useEffect(() => {
    mobileMenuBtn.current?.click();
  }, [context]);

  return (
    <div
      className="offcanvas offcanvas-start"
      tabIndex={-1}
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="offcanvasExampleLabel">
          <CustomAnchor
            path="/"
            classname="footer-fb-icon d-flex gap-2 align-items-center"
          >
            <img src={logo} alt="Standout Logo" width={55} />
            <span>Standout Fresh Produce</span>
          </CustomAnchor>
        </h5>
        <button
          ref={mobileMenuBtn}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <Navtabs />
      </div>
    </div>
  );
}

export default MobileNavbar;
